import { Vector2 } from 'three';

export class Input {
  readonly direction = new Vector2();
  private readonly keys = new Set<string>();
  private readonly touch = new Vector2();
  private pointer: number | null = null;

  constructor(joystick: HTMLElement, interact: () => void, drop: () => void) {
    const knob = joystick.querySelector<HTMLElement>('.joystick-knob')!;
    const release = () => { this.touch.set(0, 0); this.pointer = null; knob.style.transform = 'translate(0px, 0px)'; };
    window.addEventListener('keydown', e => {
      if (e.target instanceof HTMLSelectElement) return;
      if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', ' '].includes(e.key)) e.preventDefault();
      this.keys.add(e.key.toLowerCase()); if (e.key.toLowerCase() === 'e' && !e.repeat) interact();
      if (e.key.toLowerCase() === 'q' && !e.repeat) drop();
    });
    window.addEventListener('keyup', e => this.keys.delete(e.key.toLowerCase()));
    window.addEventListener('blur', () => { this.keys.clear(); release(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) { this.keys.clear(); release(); } });
    const move = (e: PointerEvent) => {
      if (e.pointerId !== this.pointer) return; const b = joystick.getBoundingClientRect();
      this.touch.set((e.clientX - b.left - b.width / 2) / 36, (e.clientY - b.top - b.height / 2) / 36); if (this.touch.length() > 1) this.touch.normalize();
      knob.style.transform = `translate(${this.touch.x * 30}px, ${this.touch.y * 30}px)`;
    };
    joystick.onpointerdown = e => { this.pointer = e.pointerId; joystick.setPointerCapture(e.pointerId); move(e); };
    joystick.onpointermove = move; joystick.onpointerup = release; joystick.onpointercancel = release; joystick.onlostpointercapture = release;
  }
  get turn(): number { return Number(this.keys.has('arrowleft')) - Number(this.keys.has('arrowright')); }
  update(firstPerson = false): Vector2 {
    this.direction.set(Number(this.keys.has('d') || (!firstPerson && this.keys.has('arrowright'))) - Number(this.keys.has('a') || (!firstPerson && this.keys.has('arrowleft'))), Number(this.keys.has('s') || this.keys.has('arrowdown')) - Number(this.keys.has('w') || this.keys.has('arrowup')));
    if (this.direction.lengthSq() === 0) this.direction.copy(this.touch); if (this.direction.length() > 1) this.direction.normalize(); return this.direction;
  }
  clear(): void { this.keys.clear(); this.touch.set(0, 0); }
}
